export class ExtraField {
  id: number;
  name: string;
  required: boolean;
}